export default __webpack_public_path__ + "static/media/placeholder_business04-jp-mobile.236a9e72.png";